import api from 'api';
import { useCallback, useState, useEffect } from 'react';
import Moment from 'react-moment';
import './activity.scss';
import { useParams } from 'react-router-dom';
import { AddActivityRequest } from 'types/AddActivityRequest';

function Activity({
    items
} : {
    items: any
}) {
    const params: any = useParams();
    const [activity, setActivity] = useState<any>();
    const [comment, setComment] = useState("");

    const addComment = () => {
        api.ticket.comment.addActivity({ ClientId: params.clientId, TicketId: params.ticketId, Comment: comment} as AddActivityRequest).then(() => {
            getActivity();
            setComment('');
        })
    }

    const getActivity = useCallback(() => {
        api.ticket.activity.getAll(params.ticketId).then((data: any) => {
            setActivity(data?.sort((a: any, b: any) => new Date(b.DateCreated).getTime() - new Date(a.DateCreated).getTime()));
        })
    }, [params.ticketId])

    const deleteComment = (id: number) => {
        api.ticket.comment.remove(id).then(() => {
            setActivity(activity.filter((x: any) => x.Id !== id));
        });
    }

    useEffect(() => {
        setActivity(items);
    }, [items])
    
    return (
        <div className="activity">
            <div className="input-group">
                <label>Activity ({activity?.length})</label>
                <div className="input-group comment">
                    <textarea value={comment} rows={3} onChange={e => setComment(e.currentTarget.value)} placeholder="Add comment"></textarea>
                    <button disabled={comment === "" ? true : false} onClick={e => addComment()}>Comment</button>
                </div>
                {activity?.map((e: any) => {
                return (
                    <div className="activity-item" key={e.Id}>
                        {e.Description && <i className="fal fa-trash" onClick={() => deleteComment(e.Id)}></i>}
                        <i className="fas fa-user-circle"></i>
                        <span className="activity-item-heading" dangerouslySetInnerHTML={{__html: e.Heading}}></span>
                        <span className="date"><Moment format="YYYY/MM/DD HH:mm">{e.DateCreated}</Moment></span>
                        {e.Description && <p dangerouslySetInnerHTML={{__html: e.Description}}></p>}
                    </div>
                )
            })}
            </div>
        </div>
    )
}

export default Activity;